import { render } from "./user-avatar.vue?vue&type=template&id=233b8713"
import script from "./user-avatar.vue?vue&type=script&lang=js"
export * from "./user-avatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__